const $ = window.jQuery

$(document).ready(function() {
    if($('#ecard-editor').length !== 0) {
        let cart = $('#ecard-editor').data('cart')
        let elementID = 'ecard-editor';
        app.init(elementID, cart)
    }
})

const app = {
    init: function(elementID, cart = []) {
        this.view = new Vue({
            el: "#" + elementID,
            data: {
                cart: cart,
            },
            mounted: function() {
                //console.log('test')
            }
        })
    }
}